// import goToScreen from './goToScreen';
// import isSiteBuilder from './isSiteBuilder';

export default function signOut(){
  // if (isSiteBuilder()) return;
  // goToScreen(null, '/log_out');
  window.location.href = "/log_out/";
  return;
}